import { CountrySelectionState, CountryMap, SelectedCountries, CountrySelection } from "app/pages/DiscountEditor/modules/CountrySelection/state";
import { Action, ActionType } from "app/pages/DiscountEditor/actionTypes";
import { CountrySelectionMode } from "app/shared/model/CountrySelectionMode";

const defaultState : CountrySelectionState = {
    selectionMode: CountrySelectionMode.AllCountries,
    countryMap: {},
    selectedCountries: {}
};


export function reducer(state: CountrySelectionState|undefined, action: Action) : CountrySelectionState {
    if (state === undefined)
        state = defaultState;

    switch (action.type) {
        case ActionType.PageLoaded:
            const countryMap : CountryMap = {};
            action.data.countries.forEach(c => {
                countryMap[c.id] = c;
            });

            const selectedCountries : SelectedCountries = {};
            
            action.discount.countryFilter.countries.forEach(c => {
                const country = countryMap[c];
                selectedCountries[c] = {
                    name: country.name,
                    id: country.id,
                    selected: true
                }
            });

            return {
                countryMap: countryMap,
                selectionMode: action.discount.countryFilter.selectionMode,
                selectedCountries: selectedCountries,
            }

        case ActionType.ChangeCountrySelectionMode:
            return {
                ... state,
                selectionMode: action.mode,
            }

        case ActionType.AddCountrySelection:
            let selection : CountrySelection = state.selectedCountries[action.countryId]
            if (!selection) {
                const country = state.countryMap[action.countryId];
                selection = {
                    id: country.id,
                    name: country.name,
                    selected: true,
                };
            }

            return {
                ...state,
                selectedCountries: {
                    ... state.selectedCountries,
                    [action.countryId]: selection
                }
            }

        case ActionType.ChangeCountrySelection:
            const newSelections : SelectedCountries = {
                ... state.selectedCountries,
                [action.countryId]: {
                    ... state.selectedCountries[action.countryId],
                    selected: action.isSelected
                }
                    
            }
            return {
                ... state,
                selectedCountries: newSelections
            }

        default:
            return state;
    }
}